import React from 'react';

export const Time = () => (
	<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1748_83066)">
			<path d="M0.5 15.3242L7.23388 14.858L8.47713 32.815L0.5 15.3242Z" fill="#FDC300" />
			<rect
				width="18"
				height="26.9158"
				transform="matrix(0.0690697 0.997612 0.997612 -0.0690697 7.2334 14.8594)"
				fill="#FDC300"
			/>
		</g>
		<path
			d="M18.5 30.375C25.3345 30.375 30.875 24.8345 30.875 18C30.875 11.1655 25.3345 5.625 18.5 5.625C11.6655 5.625 6.125 11.1655 6.125 18C6.125 24.8345 11.6655 30.375 18.5 30.375Z"
			fill="white"
		/>
		<path
			d="M18.5 18L24.0688 12.4313M15.125 1.125H21.875M30.875 18C30.875 24.8345 25.3345 30.375 18.5 30.375C11.6655 30.375 6.125 24.8345 6.125 18C6.125 11.1655 11.6655 5.625 18.5 5.625C25.3345 5.625 30.875 11.1655 30.875 18Z"
			stroke="#333333"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<defs>
			<clipPath id="clip0_1748_83066">
				<rect
					width="18"
					height="33.6658"
					fill="white"
					transform="matrix(0.0690697 0.997612 0.997612 -0.0690697 0.5 15.3242)"
				/>
			</clipPath>
		</defs>
	</svg>
);
